export default __webpack_public_path__ + "static/media/12-25.6a8b4c4d.jpeg";